import { About, Contact, Marquees, Process, References, Services } from "../../components/site/Sections";
import Hero from "../../components/site/Hero";

export default function Home() {
  return (
    <>
      <Hero />
      <Marquees />
      <Services />
      <References />
      <Process />
      <About />
      <Contact />
    </>
  );
}
